const fetchEducation = (data) => {
    lsApi.getEducation({data: data}, (jqxhr, status) => {
        if (status !== 'success') {
            console.log('Error fetching Education Data');
            return;
        }
        let response = JSON.parse(jqxhr.responseText);

        let cardListContainer = document.querySelector('.articles.card-list');
        let showListContainer = document.querySelector('.show-list');
        let cardItemTemplate = document.querySelector('#card-item-template');

        if (response.total <= 0) { // no results
            document.querySelector('.load-more').parentNode.classList.add('hidden');
            document.querySelector('#overlay').style.display = 'none';
            showListContainer.querySelector('.showing-numbers').innerHTML = 'zero results';
            return false;
        }
        
        response.education.forEach((item) => {
            let cardItem = cardItemTemplate.content.firstElementChild.cloneNode(true);
            const date = new Date(item.iso_date);
            const formattedDate = date.toISOString().split('T')[0];

            cardItem.querySelector('.card-item-image').innerHTML = item.featured_image_html;
            cardItem.querySelector('.card-item-tags').innerHTML = item.flags;
            cardItem.querySelector('.card-item-title').innerHTML = '<a href="' + item.url + '" title="' + item.title + '">' + item.title + '</a>';
            cardItem.querySelector('.card-item-date').innerHTML = item.date;
            cardItem.querySelector('.card-item-date').setAttribute('datetime', formattedDate);
            cardItem.querySelector('.card-item-description p').innerHTML = item.description;
            cardItem.querySelector('.card-item-link').href = item.url;
            cardItem.querySelector('.card-item-link').title = item.title;
            cardListContainer.appendChild(cardItem);
        });
        let currentItemsShown = document.querySelectorAll('.articles.card-list .card').length;
        showListContainer.querySelector('.showing-numbers').innerHTML = currentItemsShown + ' / ' + response.total;
        document.querySelector('.load-more').setAttribute('data-max-num-page', response.max_num_pages);
        document.querySelector('#overlay').style.display = 'none';
        
        // hide the load more button when the max num of items are reached
        if (currentItemsShown == response.total) {
            document.querySelector('.load-more').parentNode.classList.add('hidden');
        } else {
            document.querySelector('.load-more').parentElement.classList.remove('hidden');
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('#overlay').style.display = 'block';
    fetchEducation({page: 1, category: '', lang: document.querySelector('html').getAttribute('lang')}); // initial fetching of education

    let educationTabs = document.querySelectorAll('.fetch-articles');
    educationTabs.forEach((educationTab) => {
        educationTab.addEventListener('click', (event) => {
            let seletedCategory = event.target.dataset.value;
            document.querySelector('#overlay').style.display = 'block';
            document.querySelector('.card-list').innerHTML = ''; // clear out the cards first
            let searchString = document.querySelector('input[name="search-input"]').value;
            fetchEducation({page: 1, category: seletedCategory, search: searchString, lang: document.querySelector('html').getAttribute('lang')});
            
            document.querySelector('.load-more').setAttribute('data-current-page', 1);
            document.querySelector('.load-more').setAttribute('data-current-category', seletedCategory);

            educationTabs.forEach((et) => {
                et.classList.remove('btn-secondary-mid');
                et.classList.remove('btn-outline-secondary-mid');
                et.classList.add('btn-outline-secondary-mid');
            });
            event.target.classList.remove('btn-outline-secondary-mid');
            event.target.classList.add('btn-secondary-mid');
        });
    });

     /* bind actions into flags too */
     document.querySelector('.card-list').addEventListener('click', (event) => {
        if (event.target.classList.contains('fetch-articles')) {
            let seletedCategory = event.target.dataset.value;
            let categoryButtonSelector = 'button[data-value="' + seletedCategory + '"]';
            document.querySelector(categoryButtonSelector).click();
            document.querySelector('.anchor-navigation-container').scrollIntoView();
        }
    });

    let loadMoreButton = document.querySelector('.load-more');
    loadMoreButton.addEventListener('click', (event) => {
        let currentPage = parseInt(event.target.dataset.currentPage);
        let searchString = document.querySelector('input[name="search-input"]').value;
        let nextPage = currentPage + 1;
        document.querySelector('.load-more').setAttribute('data-current-page', nextPage);
        let currentCategory = document.querySelector('.load-more').dataset.currentCategory;
        document.querySelector('#overlay').style.display = 'block';
        fetchEducation({page: nextPage, category: currentCategory, search: searchString, lang: document.querySelector('html').getAttribute('lang')});
    });

    let searchForm = document.getElementById('article-form');
    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        let searchString = document.querySelector('input[name="search-input"]').value;
        if (searchString.length <= 0) {
            return false;
        }
        let currentCategory = document.querySelector('.load-more').dataset.currentCategory;
        document.querySelector('#overlay').style.display = 'block';
        document.querySelector('.card-list').innerHTML = ''; // clear out the cards first before showing the search results
        fetchEducation({page: 1, category: currentCategory, search: searchString, lang: document.querySelector('html').getAttribute('lang')});
    });
});